import EntriesIcon from './EntriesIcon';

export default EntriesIcon;
